<template>
  <div 
    class="sm-phone-input"
    :class="show_errors && isError ? 'error' : ''"
  >
    <label 
      v-if="label"
      class="sm-phone-input__label sm-small"
    >{{label}}</label>
    <tel-input
      v-model="value"
      v-bind="phoneProps"
      :validCharactersOnly="true"
      :placeholder="placeholder"
      @input="handleInput"
      @country-changed="changeCountry"
      :disabled="disabled"
    >
      <template slot="arrow-icon">
        <include-svg :name="'icon-arrow-b'" />
      </template>
    </tel-input>
    <div
      v-if="show_errors && isError"
      class="sm-phone-input__error"
    >
      <span v-if="error_text">{{error_text}}</span>
      <span v-else>Enter valid phone number</span>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import { mapGetters } from 'vuex';

export default {
  name: 'phone-input',
  components: {
    "tel-input": VueTelInput,
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    show_errors: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error_text: {
      type: String,
      default: ''
    },
    start_val: {
      type: String,
      value: ''
    },
    show_raw_input: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Enter a phone number'
    }
  },
  prop: ['value'],
  data() {
    return {
      value: '',
      phoneProps: {
        defaultCountry: "US",
        placeholder: "Enter a phone number",
        wrapperClasses: "sm-input-tel-wrap",
        inputClasses: "sm-input-tel",
        onlyCountries: [],
        //preferredCountries: ['US', 'CA', 'GB', 'AU']
      },
      oldParams: null,
      isError: false
    };
  },
  created() {
    this.phoneProps.onlyCountries = this.defaultProps.onlyCountries;

    if (this.autocomplete)
      this.phoneProps.autocomplete = this.autocomplete;

    if (this.start_val)
      this.value = this.start_val;

    if (this.error_text)
      this.isError = true;

  },
  computed: {
    ...mapGetters({
      defaultProps: 'phoneProps'
    })
  },
  methods: {
    handleInput(value, params) {
      if (!this.show_raw_input) {
        if (!this.oldParams || value.length >= this.oldParams.number.input.length) {
          if (value[0] != '+') {
            if (!value.startsWith(params.country.dialCode)) {
              value = `${params.country.dialCode}${value}`;
            }
            
            value = `+${value}`;

            this.value = value;
          } else if (!params.number.national && !value.startsWith(`+${params.country.dialCode}`)) {
            if (this.oldParams && value.startsWith(`+${this.oldParams.country.dialCode}`))
              this.value = value.replace(this.oldParams.country.dialCode, params.country.dialCode);
            else
              this.value = `+${params.country.dialCode}${value.replace(/\+/g, '')}`;
          }
        }

        let val = '';

        if (this.show_errors) {
          if (value && params.number.national && params.number.national.length > 8 && params.possible) {
            val = params.number.e164;
            this.isError = false;
          } else {
            this.isError = true;
          }
        } else {
          this.isError = false;
          val = params.number.e164 || '';
        }

        this.$emit('input', val);
      } else {
        this.$emit('input', value);
      }

      this.oldParams = params;
    },
    changeCountry(val) {
      this.$emit('country-changed', val);
    }
  },
  watch: {
    start_val(val) {
      if (val)
        this.value = val;
    },
    error_text(val) {
      if (val)
        this.isError = true;
    }
  }
}
</script>